import { render } from "./shinsei_Shutchoedit.vue?vue&type=template&id=f52d30e4&scoped=true&ts=true"
import script from "./shinsei_Shutchoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Shutchoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Shutchoedit.vue?vue&type=style&index=0&id=f52d30e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52d30e4"]])

export default __exports__